import React, { useState } from 'react';
import ModalDrawer from './ModalDrawer';
import Button, { ButtonSizes, ButtonStyles } from '../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { TRANSLATIONS } from '../../../translations';
import { BREAKPOINTS } from '../../../constants';
import Dialog, { DialogAlignments, DialogTypes } from '../Dialog/Dialog';
import Typography, {
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import { ModalCancelGiftcardForm } from './ModalCancelGiftcardForm';
import { ModalOrderCard } from './subComponents/ModalOrderCard';

const ModalCancelGiftcard = ({
  order,
  isOpen,
  setIsOpen,
  token,
  setRequestDetails,
}) => {
  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );
  const [showSecondStep, setShowSecondStep] = useState(false);

  if (!order) return <></>;

  const firstStepModal = (
    <ModalDrawer
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
      modalCustomWidth={640}
      title={TRANSLATIONS.CANCEL_GIFTCARD_REQUEST}
      content={
        <div className="pl-m pr-m pt-xl pb-xl w-100% d-flex flex-column gap-m">
          <Typography
            classNames="text-left"
            variant={TypographyVariants.p2}
            weight={TypographyWeights.bold}
          >
            {TRANSLATIONS.WANT_TO_CANCEL_GIFTCARD}
          </Typography>
          <div>
            <ModalOrderCard order={order} compact />

            <p
              className="text-left typography__p3 typography__neutral pt-xs pb-s"
              dangerouslySetInnerHTML={{
                __html:
                  TRANSLATIONS.BY_CANCELLING_THIS_GIFTCARD_YOU_WILL_LOSE_THE_OPPORTUNITY_TO_USE_IT,
              }}
            ></p>

            <Dialog
              align={DialogAlignments.row}
              type={DialogTypes.feature}
              content={TRANSLATIONS.CANCEL_GIFTCARD_INSTRUCTIONS}
              icon={
                <BetaIcon
                  name={'info'}
                  color={IconColors.regular}
                  size={IconSizes[24]}
                />
              }
            />
          </div>
        </div>
      }
      footer={
        <div className="d-flex gap-m pb-m pl-xl pr-xl">
          <Button
            classNames={'flex-1 pr-m pl-m'}
            size={ButtonSizes.s}
            style={ButtonStyles.empty}
            label={TRANSLATIONS.CANCEL}
            onClick={() => {
              setIsOpen(false);
            }}
          />
          <Button
            classNames={'flex-1 pr-m pl-m'}
            size={ButtonSizes.s}
            style={ButtonStyles.secondary}
            label={TRANSLATIONS.CONTINUE}
            onClick={() => {
              setIsOpen(false), setShowSecondStep(true);
            }}
          />
        </div>
      }
    />
  );

  const secondStepModal = (
    <ModalCancelGiftcardForm
      isOpen={showSecondStep}
      setIsOpen={setShowSecondStep}
      token={token}
      orderId={order.id}
      isDeviceSmallerThanMblLandscape={isDeviceSmallerThanMblLandscape}
      setRequestDetails={setRequestDetails}
    />
  );

  return (
    <>
      {firstStepModal}
      {secondStepModal}
    </>
  );
};

ModalCancelGiftcard.propTypes = {};

export { ModalCancelGiftcard as ModalCancelGiftcard };
